import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { WebSocketChatResponse } from "types/api"

interface webSocket {
  isSocketLoading: boolean
  response: string
  wordCurrentIndex: number
  isGeneratingResponse: boolean
  isSocketDisconnected: boolean
  botResponse: WebSocketChatResponse | null
  lastSentMessageTimestamp: number | null
  firstChunkReceived: boolean
  fallbackTriggered: boolean
  userLastMessageText: string
  isSocketConnected: boolean
}

const initialState: webSocket = {
  isSocketLoading: true,
  response: "",
  wordCurrentIndex: 0,
  isGeneratingResponse: false,
  isSocketDisconnected: false,
  botResponse: null,
  lastSentMessageTimestamp: null,
  firstChunkReceived: false,
  fallbackTriggered: false,
  userLastMessageText: "",
  isSocketConnected: false,
}

const webSocketSlice = createSlice({
  name: "web-socket",
  initialState: initialState,
  reducers: {
    setIsSocketLoading: (state, action) => {
      state.isSocketLoading = action.payload
    },
    appendResponseText: (state, action) => ({
      ...state,
      response: state.response + " " + action.payload,
    }),
    setClearResponse: (state) => ({
      ...state,
      response: "",
    }),
    setLanguageCurrentWordIndex: (state, action) => {
      state.wordCurrentIndex = action.payload
    },
    setIsGeneratingResponse: (state, action) => {
      state.isGeneratingResponse = action.payload
    },
    setIsSocketDisconnected: (state, action) => {
      state.isSocketDisconnected = action.payload
    },
    setBotResponse: (state, action) => {
      state.botResponse = action.payload
    },
    setUserLastMessageText: (state, action: PayloadAction<string>) => {
      state.userLastMessageText = action.payload
    },
    setIsSocketConnected: (state, action: PayloadAction<boolean>) => {
      state.isSocketConnected = action.payload
    },
  },
})

export const {
  setIsSocketLoading,
  appendResponseText,
  setClearResponse,
  setLanguageCurrentWordIndex,
  setIsGeneratingResponse,
  setIsSocketDisconnected,
  setBotResponse,
  setUserLastMessageText,
  setIsSocketConnected,
} = webSocketSlice.actions

export default webSocketSlice.reducer
